<template>
  <div>

    <b-tabs card v-model="step" nav-class="justify-content-around" class="card" @changed="switchTab">
      <b-tab title="Discount Type" title-item-class="card-header-tab">
        <div class="card-body">
          <h3 class="display-2">What do you want to call this promotion?</h3>
          <b-form-input v-model="campaign.title" placeholder="My first discount campaign"></b-form-input>
          <small>This name is for your own records - it is not visible to customers</small>
        </div>

        <div class="card-body">

          <h3 class="display-3">
            What kind of discount would you like to offer?
          </h3>
          <div class="row justify-content-around mt-3 mb-3">
            <div class="col-4">
              <button
                  :class="{'btn btn-lg p-5': campaign.isPrice!==false,'btn btn-lg btn-primary p-5': campaign.isPrice===false}"
                  @click="campaign.isPrice = false">
                <div>
                  <h4>Percentage or fixed $ discount</h4>
                  For example 'Buy 5, get 20% off' or 'Spend $100, save $10'
                </div>
              </button>
            </div>
            <div class="col-4"  id="isPrice">
              <button
                  :class="{'btn btn-lg p-5': campaign.isPrice!==true && !isFree,'btn btn-lg btn-primary p-5': campaign.isPrice===true && !isFree, 'btn btn-lg btn-disabled disabled': isFree}"
                  @click="!isFree ? campaign.isPrice =true : null" >
                <div>
                  <h4>Fixed price per item</h4>
                  For example 'Buy 3 for just $5 each'
                </div>
              </button>
              <b-tooltip target="isPrice" :disabled="!isFree">
                Please upgrade to a paid account to use this option
              </b-tooltip>
            </div>
          </div>
        </div>
      </b-tab>

      <b-tab title="Product Selection" title-item-class="card-header-tab">
        <div class="card-body">
          <h3 class="display-3">Limit discount to specific products?</h3>
          <div class="row justify-content-around">
            <div class="col-4" id="appliesToProducts">
              <button
                  :class="{'btn btn-lg p-5': campaign.appliesTo!=='products' && !isFree,'btn btn-lg btn-primary p-5': campaign.appliesTo==='products' && !isFree, 'btn btn-lg disabled': isFree}"
                  @click="!isFree ? campaign.appliesTo ='products' : null" >
                <div>

                  <h4>Apply to specific products</h4>
                  Let me choose the individual products that qualify
                </div>

              </button>
              <b-tooltip target="appliesToProducts" :disabled="!isFree">Please upgrade to use this option</b-tooltip>
            </div>
            <div class="col-4" id="appliesToCollections">
              <button
                  :class="{'btn btn-lg p-5': campaign.appliesTo!=='collections' && !isFree,'btn btn-lg btn-primary p-5': campaign.appliesTo==='collections' && !isFree, 'btn btn-lg disabled': isFree}"
                  @click="!isFree ? campaign.appliesTo ='collections' : null" >
                <div>
                  <h4>Apply to collections</h4>
                  Let me choose the collections where this discount will apply
                </div>
              </button>
              <b-tooltip target="appliesToCollections" :disabled="!isFree">Please upgrade to use this option</b-tooltip>
            </div>
            <div class="col-4">
              <button
                  :class="{'btn btn-lg p-5': campaign.appliesTo!=='order','btn btn-lg btn-primary p-5': campaign.appliesTo==='order'}"
                  @click="campaign.appliesTo ='order'">
                <div>
                  <h4>Apply to entire order</h4>
                  Offer the discount based on the customer's entire cart
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="card-body" v-if="campaign.appliesTo==='products'">
          <h3 class="display-3">Choose product(s)</h3>
          <button class="btn btn-lg btn-primary" @click="selectProducts">Choose</button>

          &nbsp;{{ campaign.products.length }} products selected

          <br>
          <div class="alert alert-warning card-body" v-if="!isChrome"><strong>Note:</strong> Shopify's product picker
            works best in Chrome. If you have trouble choosing your products please try re-opening the app in Chrome
          </div>
        </div>
        <div class="card-body" v-if="campaign.appliesTo==='collections'">
          <h3 class="display-3">Choose collection(s)</h3>
          <button class="btn btn-lg btn-primary" @click="selectCollections">Choose</button>
          &nbsp;{{ campaign.collections.length }} collections selected
          <br>
          <div class="alert alert-warning card-body" v-if="!isChrome"><strong>Note:</strong> Shopify's colections picker
            works best in Chrome. If you have trouble choosing your collections please try re-opening the app in Chrome
          </div>
        </div>
        <div class="card-body" v-if="campaign.appliesTo!=='order' && campaign[campaign.appliesTo].length>0">
          <b-table :items=" campaign.appliesTo=='products' ? campaign.products : campaign.collections"
                   :fields="['title','actions']">
            <template v-slot:cell(title)="data">
              <strong class="display-4">{{ data.item.title }}</strong>
              <div v-if="campaign.appliesTo==='products'">
                <strong>Variants:</strong>
                <span v-for="(variant,index) in data.item.variants"><b-link class="badge"
                                                                            title="Click to remove this variant"
                                                                            @click="removeVariant(data.index, index)">{{
                    variant.title
                  }} [x]</b-link></span>
              </div>

            </template>
            <template v-slot:cell(actions)="data">
              <button class="btn btn-sm btn-outline-danger" @click="removeProduct(data.index)">Delete
              </button>
            </template>
          </b-table>
        </div>
        <div v-if="campaign.appliesTo!=='order'" class="card-body">


          <div class="row mt-3 mb-3">
            <div class="col-sm-3 align-self-center">
              <h4>Bundle Products?</h4>
            </div>
            <div class="col">
              <b-form-select class="form-control" v-model="campaign.isBundle"
                             :options="[{text:'Yes', value:true},{text:'No',value:false}]"></b-form-select>
              <div class="polaris-caption" v-if="campaign.isBundle">
                <h4>Yes : Count All Products In Bundle</h4>
                All products in this campaign are counted towards discount.<br>
                For example, 'Buy any 3 <span
                  v-if="campaign.appliesTo==='collection'">products In these collection(s)</span><span
                  v-else>of the listed product(s)</span> To Save'.<br>
                <div class="small" v-if="campaign.isBundle">Please note: when bundling is selected there
                  will be no 'success'
                  message in the cart
                </div>
              </div>
              <div v-else class="polaris-caption">
                <h4>No : Count Each Product Separately</h4>
                To qualify the customer must buy the required quantity of a single qualifying product in
                this campaign.
              </div>
            </div>
          </div>
          <!--<div class="row justify-content-around mt-3 mb-3">
            <div class="col-4">
              <button
                  :class="{'btn btn-lg p-5': campaign.isBundle!==true,'btn btn-lg btn-primary p-5': campaign.isBundle===true}"
                  @click="campaign.isBundle = true">
                <div>
                  <h4>Yes : Count All Products In Bundle</h4>
                  All products in this campaign are counted towards discount.<br>
                  For example, 'Buy Any 3 Products In Collection To Save'
                </div>
              </button>
            </div>
            <div class="col-4">
              <button
                  :class="{'btn btn-lg p-5': campaign.isBundle!==false,'btn btn-lg btn-primary p-5': campaign.isBundle===false}"
                  @click="campaign.isBundle =false">
                <div>
                  <h4>No : Count Each Product Separately</h4>
                  To qualify the customer must buy the required quantity of a single product in this campaign.
                </div>
              </button>
            </div>
          </div>-->

          <!--<label class="polaris-check">
            <input type="checkbox" v-model="isBundle">
            <span>Bundle Products</span>
          </label>
          --><!--<b-form-checkbox class="polaris-check" v-model="isBundle">
              <span>Bundle Products</span>
            </b-form-checkbox>-->
          <!--<div class="small">Count all selected products/collections and/or variants per level. Success messages will not appear in the cart.</div>-->
        </div>
      </b-tab>
      <b-tab title="Discount Tiers" title-item-class="card-header-tab">
        <h3 class="display-3">Discount Options:</h3>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3 align-self-center">
              <h4>Discount based on the</h4>
            </div>
            <div class="col">
              <b-form-select class="form-control" v-model="campaign.prerequisiteCount"
                             :options="[
                                 {value:'quantity', text:'Quantity of goods purchased'},
                                 {value:'amount',text:'Value ($) of goods purchased'}
                                 ]"></b-form-select>
            </div>
          </div>
          <!--<div><label class="polaris-radio">
            <input type="radio" v-model="campaign.prerequisiteCount" value="quantity">
            <span>Quantity of goods purchased</span>
          </label></div>
          <div><label class="polaris-radio">
            <input type="radio" v-model="campaign.prerequisiteCount" value="amount">
            <span>Value ($) of goods purchased</span>
          </label></div>-->
        </div>
        <div class="card-body" v-if="!campaign.isPrice">
          <div class="row">
            <div class="col-sm-3 align-self-center">
              <h4>Apply discount as a</h4>
            </div>
            <div class="col">
              <b-form-select class="form-control" v-model="campaign.discountType"
                             :options="[
                                 {value:'percent',text:'Percentage'},
                                 {value:'amount',text:'Fixed Amount'}
                             ]"></b-form-select>
            </div>
          </div>
          <!--<h3 class="display-3">Apply discount as a..</h3>
          <div><label class="polaris-radio">
            <input type="radio" v-model="campaign.discountType" value='percent'>
            <span>Percentage</span>
          </label></div>
          <div><label class="polaris-radio">
            <input type="radio" v-model="campaign.discountType" value='amount'>
            <span>Fixed Amount</span>
          </label></div>-->
        </div>
        <div class="card-body" v-if="campaign.discountType=='amount' && !campaign.isPrice">
          <div class="row">
            <div class="col-sm-3 align-self-center">
              <h4>Discount fixed amount</h4>
            </div>
            <div class="col">
              <b-form-select class='form-control' :options="[
                {text:'Once for the entire order', value: false},
                {text:'Once for each eligible item', value: true}]" v-model="campaign.isEachItem"></b-form-select>
            </div>
          </div>
          <!--<label class="display-3">Discount fixed amount..</label>-->

        </div>
        <div class="card-body">
          <h3 class="display-3">Set your pricing tiers</h3>
          <b-row v-for="(tier,index) in campaign.tiers" class="align-items-center">
            <!--<div class="col">
              <span v-if="prerequisiteCount === 'quantity'">Buy</span>
              <span v-if="prerequisiteCount === 'amount'">Spend</span>
            </div>-->
            <div class="col">
              <label>
                <span v-if="campaign.prerequisiteCount === 'amount'">Spend $ amount</span>
                <span v-if="campaign.prerequisiteCount === 'quantity'">Buy this many items</span>
                <b-form-input type="number" v-model="tier.prerequisiteQuantity"
                              @change="!tier.justAdded ? tier.updated=true : null"></b-form-input>
              </label>
            </div>
            <div class="col">

              <label>
                                <span v-if="!campaign.isPrice">
                                    Save
                                  <span v-if="campaign.discountType == 'amount'">$ amount</span>
                                  <span v-if="campaign.discountType == 'percent'">% percent</span>
                                </span>
                <span v-else>
                                  Pay $x per item
                                </span>
                <b-form-input type="number" v-model="tier.value"
                              @change="!tier.justAdded ? tier.updated=true : null"
                              v-if="campaign.discountType==='percent'" max="100"></b-form-input>
                <b-form-input type="number" v-model="tier.value" step="any"
                              @change="!tier.justAdded ? tier.updated=true : null"
                              v-else></b-form-input>
              </label>
            </div>
            <div class="col text-center">
              <a class="btn btn-primary text-white"
                 @click.prevent="addTier()">Add Tier</a>
              <a class="btn btn-danger text-white" @click.prevent="campaign.tiers.splice(index,1)"
                 v-if="campaign.tiers.length>1">Remove Tier</a>
            </div>

          </b-row>

        </div>
        <div class="card-body">
          <h3 class="display-3">Plain English Example:</h3>
          <span v-if="campaign.prerequisiteCount == 'amount'">Spend more than ${{
              campaign.tiers[0].prerequisiteQuantity
            }} on</span>
          <span v-else>Buy more than {{ campaign.tiers[0].prerequisiteQuantity }} items from</span>
          <span v-if="campaign.appliesTo === 'order' ">
                the entire store
              </span>
          <span v-if="campaign.appliesTo === 'collections'">
                <span v-if="campaign.isBundle">
                  any product(s) in the chosen collection(s)
                </span>
                <span v-else>
                  any one specific product from the chosen collection(s)
                </span>
              </span>
          <span v-if="campaign.appliesTo === 'products'">
                <span v-if="campaign.isBundle">
                  any combination of the chosen product(s)
                </span>
                <span v-else>
                  any single chosen product
                </span>
              </span>
          <span v-if="!campaign.isPrice">
            and receive
            <span v-if="campaign.discountType === 'amount'">
                ${{ campaign.tiers[0].value }} discount
                <span v-if="campaign.isEachItem">
                  on every qualifying item in your cart
                </span>
                <span v-else>
                  on your total order
                </span>
              </span>
            <span v-else>
                {{ campaign.tiers[0].value }}% discount
              </span>
          </span>
          <span v-else>
            and pay ${{ campaign.tiers[0].value }} per eligible item
          </span>

        </div>
      </b-tab>
      <b-tab title="Preview" title-item-class="card-header-tab">
        <div>
          <div class="row">
            <div class="col-sm-6">
              <h4 class="display-3">Appearance Options</h4>
              <div class="card-body" v-if="!campaign.isPrice">
                <label>
                  Show quantities as
                  <b-form-select class='form-control' :options="['Basic','Range']"
                                 v-model="showQuantitiesAs"></b-form-select>
                </label>
                <!--<label v-if="showQuantitiesAs==='range'">
                  Range Display Style
                  <b-form-select  class='form-control' :options="['compact','expanded']" v-model="rangeDisplayStyle"></b-form-select>
                </label>
                <label>
                  Show table borders
                  <b-form-select class='form-control'  :options="['yes','no']" v-model="tableBorders"></b-form-select>
                </label>-->
              </div>
              <div class="card-body">
                <b-link class="display-5" v-b-toggle.table-text>Edit Table Text</b-link>
              </div>
              <b-collapse id="table-text">
                <div class="card-body">

                  <label>
                    Discount Table Header
                    <b-form-input v-model="campaign.settings.productTableHeader"
                                  placeholder="Table heading"></b-form-input>
                  </label>
                  <label>
                    Discount Description
                    <b-form-input v-model="campaign.description"
                                  placeholder="Add further instructions"></b-form-input>
                  </label>
                  <span v-if="showQuantitiesAs === 'basic'">
                    <label>
                      Quantity Column Header
                      <b-form-input v-model="campaign.settings.productTableBreaksHeader"
                                    placeholder="Quantity Column"></b-form-input>
                    </label>
                    <label>
                      Savings Column Header
                      <b-form-input v-model="campaign.settings.productTableDiscountsHeader"
                                    placeholder="Savings Column"></b-form-input>
                    </label>
                  </span>
                  <label v-if="campaign.appliesTo==='order'">
                    <label>
                      'Discount applies to entire order' text
                      <b-form-input v-model="campaign.settings.productTableEntireOrderWaring"
                                    placeholder="Discount applies to entire order"></b-form-input>
                    </label>
                  </label>
                </div>
                <div class="card-body">
                  <label>
                    Tier Descriptions
                    <div class="input-group align-items-center">
                      <b-form-input v-model="campaign.tiers[0].prefix"
                                    @input='updateTierDescriptions'></b-form-input>
                      <div class="input-group-append ml-2 mr-2">
                        &nbsp;{{ campaign.tiers[0].prerequisiteQuantity }}+&nbsp;
                      </div>
                      <b-form-input v-model="campaign.tiers[0].infix"
                                    @input='updateTierDescriptions'></b-form-input>
                      <span v-if="campaign.discountType == 'amount'">&nbsp;$</span>

                      <div class="input-group-append ml-2 mr-2">{{ campaign.tiers[0].value }}
                      </div>
                      <span v-if="campaign.discountType == 'percent'">%</span>&nbsp;
                      <b-form-input v-model="campaign.tiers[0].suffix"
                                    @input='updateTierDescriptions'></b-form-input>
                    </div>
                  </label>
                </div>
                <div class="card-body" v-if="campaign.tiers.length>5">
                  <label>Maximum Number Of Tiers To Show
                    <b-form-input v-model="campaign.settings.productTableMaxBreaksNumber"
                                  number></b-form-input>
                  </label>
                </div>
              </b-collapse>


            </div>
            <div class="col-sm-6">
              <h4 class="display-3">Preview</h4>
              <div class="well">
                <div class="justify-content-center">
                  <campaign-preview
                      :discount-type="campaign.discountType"
                      :description="campaign.description"
                      :settings="campaign.settings"
                      :tiers="campaign.tiers"></campaign-preview>

                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Confim" title-item-class="card-header-tab">
        <h3 class="display-3">Confirm & Save Your Discount</h3>
        <div class="card-body">
          <campaign-preview
              :discount-type="campaign.discountType"
              :description="campaign.description"
              :settings="campaign.settings"
              :tiers="campaign.tiers"></campaign-preview>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3  align-self-center">
              <h4>Enable Discount Campaign</h4>
            </div>
            <div class="col">
              <b-form-select class="form-control"
                             :options="[{value:true,text:'Yes - Activate Campaign'},{value:false,text:'No - Deactivate Campaign'}]"
                             v-model="campaign.isActive"></b-form-select>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3  align-self-center">
              <h4>Schedule Start Or End</h4>
            </div>
            <div class="col">
              <b-form-select class="form-control"
                             :options="[{value:true,text:'Yes '},{value:false,text:'No'}]"
                             v-model="useScheduler"></b-form-select>
            </div>
          </div>
          <div v-if="useScheduler">

            <div class="row">
              <div class="col-sm-3 align-self-center">
                <h4>Campaign Start Date</h4>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <b-form-datepicker v-model="startDay" class="form-control"
                                       :date-format-options="{year:'numeric',month:'numeric',day:'2-digit'}"
                    ></b-form-datepicker>
                  </div>
                  <div class="col">
                    <b-form-input type="time" v-model="startTime"></b-form-input>
                  </div>
                  <div class="col">
                    <b-form-select v-model="campaign.tz" class="form-control"
                                   :options="timezoneList"></b-form-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3  align-self-center">
                <h4>Set End Date</h4>
              </div>
              <div class="col">
                <b-form-select class="form-control"
                               :options="[{value:false,text:'No, run campaign indefinitely'},{value:true,text:'Yes, end campaign at a specific date'}]"
                               v-model="endCampaign"></b-form-select>
              </div>
            </div>
            <div class="row" v-if="endCampaign">
              <div class="col-sm-3 align-self-center">
                <h4>Campaign End Date</h4>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <b-form-datepicker :min="startDay" v-model="endDay"
                                       class="form-control"
                                       :date-format-options="{year:'numeric',month:'numeric',day:'2-digit'}"
                    ></b-form-datepicker>
                  </div>
                  <div class="col">
                    <b-form-input type="time" v-model="endTime"></b-form-input>
                  </div>
                  <div class="col">
                    <b-form-select v-model="campaign.tz" class="form-control"
                                   :options="timezoneList"></b-form-select>
                  </div>
                </div>
                <div class="polaris-caption">
                  Set an end date to automatically end your campaign at a specific time. Leave blank
                  to run indefinitely.
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="card-body">
          <b-link v-b-toggle.advanced-settings>Show Advanced Settings</b-link>
        </div>
        <b-collapse id="advanced-settings">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3  align-self-center">
                <h4>Only show discount to existing customers</h4>
              </div>
              <div class="col">
                <b-form-select class="form-control"
                               :options="[{value:false,text:'No, offer it to everyone'},{value:true,text:'Yes, only offer to customers'}]"
                               v-model="campaign.isForCustomers"></b-form-select>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="campaign.isForCustomers">
            <div class="row">
              <div class="col-sm-3  align-self-center">
                <h4>Only show customers with this tag</h4>
              </div>
              <div class="col">
                <b-form-input v-model="campaign.customersTag"></b-form-input>
                <div class="polaris-caption">Enter a tag such as 'Loyalty', 'VIP' or 'Wholesale' to only
                  show the discount to customers with that tag. Leave blank to show to all customers
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-3  align-self-center">
                <h4>Link Campaign Description to a URL?</h4>
              </div>
              <div class="col">
                <b-form-select class="form-control"
                               :options="[{value:false,text:'No'},{value:true,text:'Yes, link description to a url'}]"
                               v-model="campaign.isLinked"></b-form-select>
                <div class="polaris-caption">Want to offer more details on a discount campaign? Use this
                  option to link to your landing page, a collection of relevant products or your offer
                  terms.
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="campaign.isLinked">
            <div class="row">
              <div class="col-sm-3  align-self-center">
                <h4>Link Url</h4>
              </div>
              <div class="col">
                <b-form-input v-model="campaign.linkurl"></b-form-input>
                <div class="polaris-caption">Enter the url you wish to link to. Note we don't check the
                  link is valid, so please test it first 😀
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

      </b-tab>
    </b-tabs>
    <div class="row">
      <div class="col-6 text-left">
        <button class="btn btn-outline-secondary btn-sm" v-if="step>0" @click="step--">Back</button>
      </div>

      <div class="col-6 text-right">
                <span v-if="step <4">
                    <button class="btn btn-success btn-lg" @click="step++"
                            v-if="!validateNext()['disabled']">Next</button>
                    <div v-else tabindex=0>
                        <span class="badge badge-info">{{ validateNext().message }}</span>&nbsp;
                        <button class="btn btn-success btn-lg" @click="step++" style="pointer-events: none;" disabled>Next</button>
                    </div>
                </span>

        <button class="btn btn-success" v-if="step === 4" @click="saveCampaign">Save</button>
      </div>
    </div>
    <b-modal ref="campaign-saved" centered title="Your campaign is saved!" @ok="goDashboard">
      <div class="text-center">
        <svg id="c9533a1a-3341-4132-b58a-1916f0ec6876" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="250" height="200" viewBox="0 0 1074 739" class="injected-svg gridItem__media"><defs><linearGradient id="cf277671-cf0a-49c3-95f9-02fb51e7bec0-1264" x1="607.35" y1="789.64" x2="607.35" y2="80.5" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="gray" stop-opacity="0.25"></stop><stop offset="0.54" stop-color="gray" stop-opacity="0.12"></stop><stop offset="1" stop-color="gray" stop-opacity="0.1"></stop></linearGradient></defs><title>successful purchase</title><rect x="330" y="77" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="568" y="50" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="524" y="355" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="560" y="388" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="774" y="373" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="123" y="397" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="499" y="421" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><path d="M781.91,262.71,745.25,156.29l-13.18,2-11.8,1.51c.3-4,.82-18.36-6.5-25.89-.71-2.58-2.58-5.51-6.18-8.81-17.54-16.08-21.19,16.81-21.19,16.81s-4,6.94-9.51,16.64L674,158l-.82,7.16c-12.2,21.57-28.41,50.76-28.41,53.5,0,4.39-2.19,10.23-2.19,10.23s-12.42,20.46-16.81,30.7a49.09,49.09,0,0,1-11,16.08s-1.06.81-2.8,2a25,25,0,0,1,1-5.71c1.6-5.23,5.32-9.71,6.31-15.09a17.62,17.62,0,0,0,.26-3.91c.23-6.31-2.84-12.52-4.12-18.83-1.49-7.31-.69-15.36-4.59-21.71-3-4.85-8.32-7.87-13.85-9.26-5.08-1.27-10.08-.82-15.2-1.36-4.7-.5-9.19-2.58-13.89-3.35a17.93,17.93,0,0,0-7.62,0c-7.95,2.19-10.44,12.21-16.58,17.72-2.21,2-4.92,3.38-6.92,5.57-2.91,3.19-3.92,7.64-3.77,12a25.56,25.56,0,0,0,.26,4.37c.76,5.23,2.78,10.18,4,15.31a53,53,0,0,1,1.49,11.59c0,.88,0,1.76-.08,2.63a9.23,9.23,0,0,1-1.35,5c-1.11,1.53-2.94,2.27-4.57,3.25a35.45,35.45,0,0,1-11.52-16.34s-.27.34-.73,1v-1s-10-14.68-11.52-26.67l3.48.36,8-112.55-20.43-3c-.57-5.81-2.12-14.24-6.23-20.39,3.43-6.76,5.16-15.91-9.88-16.82-17.6-1.07-16.52,12.64-14.65,20.14a50.45,50.45,0,0,0-1,12.45l-18-2.62-.1,1.46h-4.28L432.79,226.73l11.16-.56,40.9,4.26c3.27,29.73,8.41,66.47,14.51,75.13a7.39,7.39,0,0,0,.67.83V359s-.73,68-13.16,78.93a65,65,0,0,1,23.78-3.73c-.14.45-.28.93-.42,1.44a127.58,127.58,0,0,0-3.79,20.48q-.26,2.29-.47,4.78a257.87,257.87,0,0,0,.63,45.73c5.12,54.08,13.16,92.82,13.16,92.82L522,630.89s-2.19,53.35,3.65,70.89a26.47,26.47,0,0,0,7.48,4.85c.05.5.11,1,.16,1.53s.13,1.35.2,2.05c-2.62,1.19-7.51,5.91-8.57,24.45,0,0,1.46,13.89-2.19,20.46s-1.46,25.58,9.5,27.77a58.57,58.57,0,0,0,21.19,0s5.12,0,1.46-18.27l-.64-4.68c-.08-9.05.3-18.74,2.1-21.63,3.65-5.85-1.46-11.69-1.46-11.69s-.36.2-.95.47c-.94-5.05-2.17-13.25-1.73-19.51,0-.53.09-1,.15-1.55a30.78,30.78,0,0,0,6.19-4.27V632.35s-.73-106.7,7.31-108.9c0,0,3.65,38.73,2.19,57.74s2.19,39.47,2.19,39.47l1.46,77.47s1.4.67,3.66,1.46l-.15,1.41c-.89,8.61-2.32,21.61-3.62,29.57a5.88,5.88,0,0,0-3.55,4.1c-2.19,7.31-.73,25.58-5.12,30.7-2.59,3-5.69,9.11-4.17,13.43-.95,3.79-.53,9.71,10.75,10.69,16.81,1.46,24.12-7.31,24.12-7.31s2.19-3.65,0-10.23.73-18.27.73-18.27,1.57-9.92-1-11.22c-.22-1.18-.42-1.93-.42-1.93a8.8,8.8,0,0,0-2.31-6.08c-.06-7.65.25-21.8,2.94-31.12.16-.53.32-1,.49-1.55a19.74,19.74,0,0,0,6.18-2.17s-.73-16.81,4.39-28.5,2.19-58.47,2.19-58.47-2.19-12.29.9-22.25a218.32,218.32,0,0,0,7.94-33.8l4.31-30.19s11.35-36.75-3.6-74.47c-.61-1.56-1.28-3.12-2-4.68-1.24-2.71-2.62-5.43-4.16-8.13-.24-.42-.5-.85-.75-1.27,1.57-.39,2.46-.62,2.46-.62s-19.73-46-7.31-69.43c0,0,7-7,8-14.69,1.24-10.17,2.59-20.33,4.81-30.33l.39-1.76s.06-.34.16-.95c.28-.18.55-.37.82-.57,21.06-15.38,39.22-79.6,39.22-79.6l5.85-11,2.78-5.88-5.7,49.73,44.58,11,28.5-2.19-.08-6.13,21.72-1.69Zm-282.6-145-7.92-1.16c-1.39-7.15-2.33-11.84-2.33-11.84a43.44,43.44,0,0,0,4.39-6.57C497.28,104,498.75,112,499.31,117.67Zm-29.58-15.35c.55,1.88,1.05,3.09,1.05,3.09l1,8.25-2.7-.39A54.19,54.19,0,0,1,469.74,102.32Zm249.8,57.61-10.72,1.38c1.51-4.44,3.38-11.72,2.29-18.31a9.19,9.19,0,0,0,2.94-7.65C720.41,143,719.81,156.44,719.53,159.94Zm-17.8-11.41a26.56,26.56,0,0,0,8.73-4.91c.92,6.47-1,13.58-2.46,17.8l-10,1.28-2.76-.53Z" transform="translate(-63 -80.5)" fill="url(#cf277671-cf0a-49c3-95f9-02fb51e7bec0-1264)"></path><polygon points="717 184.1 690.91 194.99 660.6 89.3 667.71 80.86 680.74 78.84 717 184.1" fill="#6c63ff"></polygon><polygon points="717 184.1 690.91 194.99 660.6 89.3 667.71 80.86 680.74 78.84 717 184.1" fill="#fff" opacity="0.2"></polygon><polygon points="667.71 80.86 622.43 86.67 645.64 198.51 690.91 194.99 667.71 80.86" fill="#6c63ff"></polygon><polygon points="667.71 80.86 622.43 86.67 645.64 198.51 690.91 194.99 667.71 80.86" fill="#fff" opacity="0.07"></polygon><path d="M718.94,163.88l-.72-.09c0-.27,3-26.67-13.57-30l.14-.71C722.07,136.55,719,163.61,718.94,163.88Z" transform="translate(-63 -80.5)" fill="#535461"></path><rect x="488.44" y="160.44" width="49.88" height="73.01" fill="#774e55"></rect><rect x="488.44" y="160.44" width="49.88" height="73.01" opacity="0.2"></rect><polygon points="669.51 202.72 641.32 204.89 645.66 95.02 655.05 89.24 668.06 91.41 669.51 202.72" fill="#6c63ff"></polygon><polygon points="669.51 202.72 641.32 204.89 645.66 95.02 655.05 89.24 668.06 91.41 669.51 202.72" opacity="0.2"></polygon><polygon points="655.05 89.24 610.24 80.56 597.23 194.05 641.32 204.89 655.05 89.24" fill="#6c63ff"></polygon><polygon points="391.22 35.03 384.71 35.03 371.7 148.51 400.61 147.07 391.22 35.03" fill="#6c63ff"></polygon><polygon points="391.22 35.03 384.71 35.03 371.7 148.51 400.61 147.07 391.22 35.03" opacity="0.2"></polygon><polygon points="389.05 33.58 381.1 147.79 450.49 155.02 458.44 43.7 389.05 33.58" fill="#6c63ff"></polygon><path d="M535.9,706.81s-8.67-.72-10.12,24.58c0,0,1.45,13.73-2.17,20.24s-1.45,25.3,9.4,27.47a57.93,57.93,0,0,0,21,0s5.06,0,1.45-18.07l-7.23-52.77Z" transform="translate(-63 -80.5)" fill="#5c3d53"></path><path d="M535.9,706.81s-8.67-.72-10.12,24.58c0,0,1.45,13.73-2.17,20.24s-1.45,25.3,9.4,27.47a57.93,57.93,0,0,0,21,0s5.06,0,1.45-18.07l-7.23-52.77Z" transform="translate(-63 -80.5)" opacity="0.05"></path><path d="M581.35,289.4c-.62,10.76,1.53,17,1.53,17l-18.79,5.06s-31.08,4.34-18.79-8c4.25-4.25,6.34-11.54,7.25-19.24a106.62,106.62,0,0,0,.53-15.84,141.2,141.2,0,0,0-1.28-14.8s45.54-15.9,35.42,10.12a92.54,92.54,0,0,0-4.35,14.5A76.45,76.45,0,0,0,581.35,289.4Z" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><path d="M587.22,263.71a92.54,92.54,0,0,0-4.35,14.5,31.14,31.14,0,0,1-29.79-9.82,141.2,141.2,0,0,0-1.28-14.8S597.34,237.69,587.22,263.71Z" transform="translate(-63 -80.5)" opacity="0.1"></path><circle cx="513.38" cy="165.86" r="31.08" fill="#f8bdc5"></circle><path d="M521.44,261.54v9.4l-15.9,41.2-4.34-4.34a7.3,7.3,0,0,1-.66-.82c-10.5-14.92-18.14-114.11-18.14-114.11L472.29,109s-10.84-26,13-24.58,5.06,23.85,5.06,23.85,15.9,79.51,13.73,82.4,0,11.57,0,11.57,6.51,16.63,5.78,28.91S521.44,261.54,521.44,261.54Z" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><path d="M700.7,151.67l-37.59,79.51L657.33,242s-18,63.52-38.79,78.73a19,19,0,0,1-3.86,2.23l-4.34-34.7,4-10.08.3-.77a48.55,48.55,0,0,0,10.84-15.9c4.34-10.12,16.63-30.36,16.63-30.36s2.17-5.78,2.17-10.12,41.2-75.9,41.2-75.9,3.61-32.53,21-16.63S700.7,151.67,700.7,151.67Z" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><path d="M555.41,728.49s-24.58,10.12-21.69.72c1.76-5.7,1.11-16.47.33-24-.5-4.91-1.06-8.49-1.06-8.49l21,2.17a17,17,0,0,0-1.21,5.75C552.09,714.23,555.41,728.49,555.41,728.49Z" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><path d="M593.63,700.37c-3.79,13.16-2.8,36.08-2.8,36.08s-22.41,2.89-20.24-2.89c1.51-4,3.72-23.82,4.92-35.47.53-5.09.86-8.62.86-8.62l20.24,4.34A20.22,20.22,0,0,0,593.63,700.37Z" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><path d="M533,696.69l21,2.17a17,17,0,0,0-1.21,5.75,21.43,21.43,0,0,1-18.7.57C533.56,700.26,533,696.69,533,696.69Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M596.62,693.8a20.22,20.22,0,0,0-3,6.57c-6.83,1.1-14-.83-18.11-2.28.53-5.09.86-8.62.86-8.62Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M619.75,525.37l-4.26,29.86a215.92,215.92,0,0,1-7.86,33.43c-3.06,9.85-.89,22-.89,22s2.89,46.26-2.17,57.83-4.34,28.19-4.34,28.19c-11.57,6.51-28.19-1.45-28.19-1.45l-1.45-76.62s-3.61-20.24-2.17-39-2.17-57.1-2.17-57.1c-8,2.17-7.23,107.7-7.23,107.7v68.67c-17.35,15.18-32.53,0-32.53,0-5.78-17.35-3.61-70.12-3.61-70.12l-2.17-31.08s-8-38.31-13-91.8a255,255,0,0,1-.62-45.23q.21-2.46.46-4.73a126.18,126.18,0,0,1,3.74-20.25,45.58,45.58,0,0,1,2.2-6.41l77.67,3.61,4.58.21,11,.51c1.2,1.81,2.33,3.65,3.38,5.49,1.52,2.67,2.89,5.36,4.11,8,.7,1.54,1.36,3.09,2,4.63C631,489,619.75,525.37,619.75,525.37Z" transform="translate(-63 -80.5)" fill="#5e52ad"></path><path d="M534.45,436.47s-3.4,34-27.37,24.16q.21-2.46.46-4.73c5.64,1.53,21.25,3.64,21.84-19.44Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M616.19,451.72c-16.6,5.93-22.86-9.86-25-18.87l4.58.21c2.49,14.17,12.43,15,18.48,14C614.93,448.64,615.58,450.19,616.19,451.72Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M542.34,724.65c-3.69-.58-9.33-2.61-7.56-9.7,0,0-6.83-2.36-6.11,25.83,0,0-.72,13.73-2.17,16.63s0,20.24,15.18,18.79c0,0,10.84,3.61,13.73-2.17,0,0-2.17-33.25,1.45-39s-1.45-11.57-1.45-11.57-5.12,2.84-8.8,2C545.21,725.07,543.77,724.88,542.34,724.65Z" transform="translate(-63 -80.5)" fill="#5c3d53"></path><path d="M560.47,771.86s-7.23,12.29,9.4,13.73,23.85-7.23,23.85-7.23,2.17-3.61,0-10.12.72-18.07.72-18.07,2.17-13.73-2.89-10.84S560.47,771.86,560.47,771.86Z" transform="translate(-63 -80.5)" fill="#5c3d53"></path><path d="M560.47,771.86s-7.23,12.29,9.4,13.73,23.85-7.23,23.85-7.23,2.17-3.61,0-10.12.72-18.07.72-18.07,2.17-13.73-2.89-10.84S560.47,771.86,560.47,771.86Z" transform="translate(-63 -80.5)" opacity="0.05"></path><path d="M579.27,727.77s-8.67-3.61-10.84,3.61-.72,25.3-5.06,30.36-10.12,18.79,7.23,18.07,21-6.51,21-6.51-.72-18.07,1.45-23.13,0-13,0-13S593.72,727,579.27,727.77Z" transform="translate(-63 -80.5)" fill="#5c3d53"></path><circle cx="407.84" cy="43.7" r="1.45" opacity="0.2"></circle><circle cx="438.2" cy="47.31" r="1.45" opacity="0.2"></circle><path d="M501.56,127.82l-.72,0c0-.31.51-30.8-17-33.61-3.45-.55-6.27.23-8.38,2.32-7.23,7.17-4.24,27.42-4.21,27.62l-.71.11c-.13-.85-3.07-20.82,4.42-28.24,2.28-2.27,5.32-3.12,9-2.53C502.08,96.39,501.57,127.51,501.56,127.82Z" transform="translate(-63 -80.5)" fill="#535461"></path><path d="M706.09,168.45l-.65-.31c.11-.24,11.25-24.37-3.47-32.78l.36-.63C717.62,143.47,706.21,168.2,706.09,168.45Z" transform="translate(-63 -80.5)" fill="#535461"></path><path d="M582.88,306.36l-18.79,5.06s-31.08,4.34-18.79-8c4.25-4.25,6.34-11.54,7.25-19.24,4.91,7.7,10.82,5.51,10.82,5.51l17.92-.35.07,0C580.73,300.16,582.88,306.36,582.88,306.36Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M618.55,320.75a19,19,0,0,1-3.86,2.23l-4.34-34.7,4-10.08,1-.77C624.38,280,619.72,313.24,618.55,320.75Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M521.44,261.54v9.4l-15.9,41.2-4.34-4.34a7.3,7.3,0,0,1-.66-.82C502.42,285.5,521.44,261.54,521.44,261.54Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M610.11,439.06c-10.11,2.53-62.89,14.93-78.55,3.19-6.18-4.63-13.46-6.33-20.27-6.6a45.58,45.58,0,0,1,2.2-6.41l77.67,3.61,4.58.21,11,.51C607.94,435.39,609.06,437.22,610.11,439.06Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M474.1,90.59s10.84,18.07,18.07,0" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><path d="M697.09,127.81s-4.34,21.69,13,11.57" transform="translate(-63 -80.5)" fill="#f8bdc5"></path><g opacity="0.1"><path d="M562.89,529.64c-.35-4.4-.61-7.15-.61-7.15-8,2.17-7.23,107.7-7.23,107.7v68.67c-5.08,4.44-10,6.28-14.35,6.67,5.22.46,11.44-1,18-6.67V630.19S558.14,553.72,562.89,529.64Z" transform="translate(-63 -80.5)"></path><path d="M615.83,451.72c-.61-1.54-1.26-3.09-2-4.63-1.22-2.68-2.59-5.37-4.11-8-1-1.84-2.18-3.67-3.38-5.49l-11-.51-4.58-.21-77.67-3.61-.07.16,74.13,3.45,4.58.21,11,.51c1.2,1.81,2.33,3.65,3.38,5.49,1.52,2.67,2.89,5.36,4.11,8,.7,1.54,1.36,3.09,2,4.63,14.78,37.3,3.56,73.65,3.56,73.65l-4.26,29.86a215.92,215.92,0,0,1-7.86,33.43c-3.06,9.85-.89,22-.89,22s2.89,46.26-2.17,57.83-4.34,28.19-4.34,28.19a21,21,0,0,1-9.06,2.5,23,23,0,0,0,12.67-2.5s-.72-16.63,4.34-28.19,2.17-57.83,2.17-57.83-2.17-12.16.89-22a215.92,215.92,0,0,0,7.86-33.43l4.26-29.86S630.61,489,615.83,451.72Z" transform="translate(-63 -80.5)"></path></g><path d="M581.29,290.82c10,4.71,33.4-13.38,33.4-13.38,10.12,2.89,2.89,44.82,2.89,44.82l-.39,1.74c-2.2,9.89-3.53,19.94-4.76,30-.93,7.59-7.86,14.53-7.86,14.53-12.29,23.13,7.23,68.67,7.23,68.67s-62.89,16.63-80.23,3.61-43.37-2.89-43.37-2.89c12.29-10.84,13-78.07,13-78.07v-52c1.45-21.69,21-46.26,21-46.26,8,22.41,30.23,23.89,30.23,23.89,4.93,8,11,5.75,11,5.75Z" transform="translate(-63 -80.5)" fill="#eb6475"></path><path d="M568.29,202.56a17.73,17.73,0,0,0-7.53,0c-7.86,2.17-10.33,12.08-16.4,17.52-2.18,2-4.87,3.34-6.85,5.51-3.52,3.86-4.23,9.58-3.48,14.75s2.75,10.07,4,15.14A52.39,52.39,0,0,1,539.42,271a9.13,9.13,0,0,1-1.34,4.91c-1.45,2-4.12,2.63-6,4.23-5.74,4.94-1,15.19-5.21,21.5-1.81,2.73-5.2,4.53-5.89,7.73-.49,2.27.55,4.56,1.57,6.65,2.68,5.5,5.46,11.15,10,15.25s10.15,6.16,15.73,8.25c1.69.63,3.81,1.18,5.1-.07,1.59-1.56.39-4.2-.71-6.13-1.74-3-3.1-6.62-2.08-10s4.29-5.62,6.49-8.44c5.67-7.3,3.81-17.78,1-26.58-1.19-3.71-2.53-7.66-1.52-11.43.43-1.62,1.28-3.09,1.82-4.68,2.4-7.08-1.63-14.85-.45-22.23a31.93,31.93,0,0,1,3-8.27l6.35-13.65a13.49,13.49,0,0,1,2.81-4.42,10,10,0,0,1,7-2.18,19,19,0,0,1,13.63,6.21c6.8,7.56,6.37,19,5.55,29.08l-.59,7.28c-.43,5.24-1,10.83-4.3,14.91-2.57,3.16-6.72,5.31-7.78,9.25-.92,3.39.81,7.07-.1,10.46-1.36,5.07-7.62,6.9-10.93,11a11.25,11.25,0,0,0-.82,12.65c1.26,2,3.27,4,3,6.35-.23,1.89-1.93,3.42-1.92,5.32a4.23,4.23,0,0,0,3.07,3.67,12.4,12.4,0,0,0,5.07.24l17.93-1.62a6.31,6.31,0,0,0,3.19-.88c1.25-.9,1.66-2.56,1.83-4.09.72-6.38-1-13.35,2.19-18.93,1-1.79,2.47-3.28,3.58-5,6.12-9.6-.05-22.62,3.28-33.51,1.58-5.17,5.26-9.61,6.24-14.92,1.3-7.08-2.39-14-3.82-21-1.47-7.23-.68-15.19-4.54-21.48-2.95-4.8-8.23-7.79-13.69-9.16-5-1.26-10-.81-15-1.35C577.38,205.37,572.94,203.31,568.29,202.56Z" transform="translate(-63 -80.5)" opacity="0.1"></path><path d="M568.29,201.11a17.73,17.73,0,0,0-7.53,0c-7.86,2.17-10.33,12.08-16.4,17.52-2.18,2-4.87,3.34-6.85,5.51-3.52,3.86-4.23,9.58-3.48,14.75s2.75,10.07,4,15.14a52.39,52.39,0,0,1,1.39,15.52,9.13,9.13,0,0,1-1.34,4.91c-1.45,2-4.12,2.63-6,4.23-5.74,4.94-1,15.19-5.21,21.5-1.81,2.73-5.2,4.53-5.89,7.73-.49,2.27.55,4.56,1.57,6.65,2.68,5.5,5.46,11.15,10,15.25s10.15,6.16,15.73,8.25c1.69.63,3.81,1.18,5.1-.07,1.59-1.56.39-4.2-.71-6.13-1.74-3-3.1-6.62-2.08-10s4.29-5.62,6.49-8.44c5.67-7.3,3.81-17.78,1-26.58-1.19-3.71-2.53-7.66-1.52-11.43.43-1.62,1.28-3.09,1.82-4.68,2.4-7.08-1.63-14.85-.45-22.23a31.93,31.93,0,0,1,3-8.27l6.35-13.65a13.49,13.49,0,0,1,2.81-4.42,10,10,0,0,1,7-2.18,19,19,0,0,1,13.63,6.21c6.8,7.56,6.37,19,5.55,29.08l-.59,7.28c-.43,5.24-1,10.83-4.3,14.91-2.57,3.16-6.72,5.31-7.78,9.25-.92,3.39.81,7.07-.1,10.46-1.36,5.07-7.62,6.9-10.93,11a11.25,11.25,0,0,0-.82,12.65c1.26,2,3.27,4,3,6.35-.23,1.89-1.93,3.42-1.92,5.32a4.23,4.23,0,0,0,3.07,3.67,12.4,12.4,0,0,0,5.07.24l17.93-1.62a6.31,6.31,0,0,0,3.19-.88c1.25-.9,1.66-2.56,1.83-4.09.72-6.38-1-13.35,2.19-18.93,1-1.79,2.47-3.28,3.58-5,6.12-9.6-.05-22.62,3.28-33.51,1.58-5.17,5.26-9.61,6.24-14.92,1.3-7.08-2.39-14-3.82-21-1.47-7.23-.68-15.19-4.54-21.48-2.95-4.8-8.23-7.79-13.69-9.16-5-1.26-10-.81-15-1.35C577.38,203.93,572.94,201.87,568.29,201.11Z" transform="translate(-63 -80.5)" fill="#774e55"></path><path d="M529.75,366.71s14.46,4.34,35.42-5.06H576s.72,10.12,28.91,5.78" transform="translate(-63 -80.5)" opacity="0.1"></path><ellipse cx="537" cy="690" rx="537" ry="49" fill="#6c63ff" opacity="0.1"></ellipse><rect x="252" y="258" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="288" y="291" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="603" y="260" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="639" y="293" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="227" y="324" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="307" y="441" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="343" y="474" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="282" y="507" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="629" y="525" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><rect x="568" y="558" width="80" height="30" rx="5.17" ry="5.17" fill="#6c63ff" opacity="0.1"></rect><g opacity="0.1"><path d="M1008.26,743.89s-14.48-73.36,15.34-123.64a113.3,113.3,0,0,0,15.63-69.94,190.55,190.55,0,0,0-7-34.14" transform="translate(-63 -80.5)" fill="none" stroke="#535461" stroke-miterlimit="10" stroke-width="2"></path><path d="M1050.85,484.37c-.8,8.75-19,32.68-19,32.68s-13.52-26.84-12.71-35.6a15.92,15.92,0,0,1,31.7,2.91Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M1072.6,535.27c-5.43,6.91-33.7,17.12-33.7,17.12s3.24-29.88,8.67-36.79a15.92,15.92,0,1,1,25,19.67Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M1063.84,618c-8.18,3.22-37.73-2.24-37.73-2.24s17.88-24.16,26.06-27.38A15.92,15.92,0,0,1,1063.84,618Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M1043.11,679.15c-7.52,4.56-37.57,4.17-37.57,4.17s13.54-26.83,21.06-31.39a15.92,15.92,0,1,1,16.51,27.22Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M1005.46,551c5.72,6.68,34.39,15.68,34.39,15.68s-4.5-29.72-10.21-36.39A15.92,15.92,0,1,0,1005.46,551Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M982.12,622.82c7.45,4.66,37.51,4.67,37.51,4.67s-13.18-27-20.64-31.67a15.92,15.92,0,1,0-16.87,27Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M969,695.71c6.56,5.85,36.18,10.95,36.18,10.95s-8.43-28.85-15-34.7A15.92,15.92,0,1,0,969,695.71Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path></g><g opacity="0.1"><path d="M882.63,727.79s-7.77-39.39,8.23-66.39a60.84,60.84,0,0,0,8.39-37.56,102.32,102.32,0,0,0-3.74-18.33" transform="translate(-63 -80.5)" fill="none" stroke="#535461" stroke-miterlimit="10" stroke-width="2"></path><path d="M905.5,588.43c-.43,4.7-10.2,17.55-10.2,17.55s-7.26-14.41-6.83-19.11a8.55,8.55,0,0,1,17,1.56Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M917.17,615.76c-2.92,3.71-18.1,9.19-18.1,9.19s1.74-16,4.66-19.75a8.55,8.55,0,0,1,13.44,10.56Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M912.47,660.2c-4.39,1.73-20.26-1.2-20.26-1.2s9.6-13,14-14.7a8.55,8.55,0,0,1,6.27,15.9Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M901.34,693c-4,2.45-20.17,2.24-20.17,2.24s7.27-14.41,11.31-16.86A8.55,8.55,0,1,1,901.34,693Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M881.12,624.22c3.07,3.59,18.47,8.42,18.47,8.42s-2.41-16-5.48-19.54a8.55,8.55,0,0,0-13,11.12Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M868.59,662.77c4,2.5,20.14,2.51,20.14,2.51s-7.08-14.5-11.08-17a8.55,8.55,0,0,0-9.06,14.5Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M861.56,701.91c3.52,3.14,19.43,5.88,19.43,5.88s-4.52-15.49-8-18.63a8.55,8.55,0,0,0-11.38,12.76Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path></g><g opacity="0.1"><path d="M249.63,733.79s-7.77-39.39,8.23-66.39a60.84,60.84,0,0,0,8.39-37.56,102.32,102.32,0,0,0-3.74-18.33" transform="translate(-63 -80.5)" fill="none" stroke="#535461" stroke-miterlimit="10" stroke-width="2"></path><path d="M272.5,594.43c-.43,4.7-10.2,17.55-10.2,17.55s-7.26-14.41-6.83-19.11a8.55,8.55,0,0,1,17,1.56Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M284.17,621.76c-2.92,3.71-18.1,9.19-18.1,9.19s1.74-16,4.66-19.75a8.55,8.55,0,0,1,13.44,10.56Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M279.47,666.2c-4.39,1.73-20.26-1.2-20.26-1.2s9.6-13,14-14.7a8.55,8.55,0,0,1,6.27,15.9Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M268.34,699c-4,2.45-20.17,2.24-20.17,2.24s7.27-14.41,11.31-16.86A8.55,8.55,0,1,1,268.34,699Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M248.12,630.22c3.07,3.59,18.47,8.42,18.47,8.42s-2.41-16-5.48-19.54a8.55,8.55,0,0,0-13,11.12Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M235.59,668.77c4,2.5,20.14,2.51,20.14,2.51s-7.08-14.5-11.08-17a8.55,8.55,0,0,0-9.06,14.5Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path><path d="M228.56,707.91c3.52,3.14,19.43,5.88,19.43,5.88s-4.52-15.49-8-18.63a8.55,8.55,0,0,0-11.38,12.76Z" transform="translate(-63 -80.5)" fill="#6c63ff"></path></g></svg>
        <div v-if="campaign.isActive" class="display-3">
          Your discount campaign is now
          <span v-if="useScheduler">scheduled!</span
          ><span v-else>live!</span>
        </div>
        <div v-else style="margin-bottom:10px">
          <div class="display-3">Your campaign is saved as a draft.</div>
          To go live choose 'Activate the campaign' and save it again.
        </div>
        <div style="margin:20px">We love to hear your feedback!<br>
          Please <b-link
            href="https://apps.shopify.com/smarty-discounts/reviews" target="_blank">leave us a review</b-link> 😍</div>
        <div>Any questions? We're here to help! <b-link @click="openChat">Just drop us a line at support.</b-link></div>
      </div>

      <template #modal-cancel>Keep Editing</template>
      <template #modal-ok>Return To Dashboard</template>
    </b-modal>
  </div>

</template>

<script>

import createApp from '@shopify/app-bridge'
import { ResourcePicker, Toast } from '@shopify/app-bridge/actions'
import React, { useContext } from 'react'
import { Context } from '@shopify/app-bridge-react'

// const appBridge = useContext(Context)
import vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import CampaignPreview from '@/vue/CampaignPreview'
// Install BootstrapVuev
vue.use(BootstrapVue)
// import 'bootstrap/dist/css/bootstrap.css'
// import '@/../sass/bootstrap-polaris/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Moments, Strings, Numbers } from '@/components/utilities'

export default {
  name: 'CampaignWizard',
  components: { 'campaign-preview': CampaignPreview },
  data () {
    return {
      step: 0,
      defaultTier: {
        prerequisiteQuantity: 2,
        value: 10,
        prefix: 'Buy',
        infix: 'Get',
        suffix: 'Off',
        justAdded: true,
        updated: false,
      },
      endCampaign: false,
      campaign: {
        id: null,
        isActive: true,
        isBundle: false,
        isPrice: false,
        isLinked: false,
        isEachItem: true,
        isForCustomers: false,
        customersTag: '',
        description: '',
        linkurl: '',
        title: '',
        prerequisiteCount: 'quantity',
        discountType: 'percent',
        appliesTo: 'products',
        startsAt: Moments.getCurrentMomentLocal(null),
        endsAt: null,
        tz: Moments.getLocalTZ(),
        moneyFormat: '{{amount}}',
        qualify: 'products',
        tiers: [
          {
            prerequisiteQuantity: 2,
            value: 10,
            prefix: 'Buy',
            infix: 'Get',
            suffix: 'Off',
            justAdded: true,
            updated: false,
          },
        ],
        products: [],
        collections: [],
        settings: {
          'productTableHeader': 'Buy More To Save',
          'productTableBreaksHeader': 'Number',
          'productTableDiscountsHeader': 'Saving',
          'productTableShowDescription': true,
          'productTableMaxBreaksNumber': '15',
          'productTableEntireOrderWaring': 'Applies to entire order',
          'productTableShowEntireOrderWaring': true,
          'productTableHiddenBreaksWarning': '%s more tiers(s) are not visible here',
          'productTableHandle': 'basic',
          'cartSuccessShowMessage': true,
          'cartSuccessShowSavedPercent': true,
          'cartSuccessSavedAmountMessage': 'Saved',
          'cartUpsellShowMessage': true,
          'cartUpsellShowSavedPercent': true,
          'cartUpsellSavedAmountMessage': 'Click to buy %s items and save',

        },

      },
      showQuantitiesAs: 'basic',
      rangeDisplayStyle: 'compact',
      tableBorders: 'no',
      startDate: Moments.getCurrentMomentLocal(null),
      timezone: Moments.getLocalTZ(),
      setEndDate: false,
      endDate: null,
      timezoneList: [],
      useScheduler: false,
      startDay: null,
      startTime: null,
      endDay: null,
      endTime: null,
      isChrome: true,
      isLoaded: false,
      isFree: false,
      /*productPicker: null,
      collectionPicker:null,*/
    }
  },
  methods: {
    goDashboard () {
      window.location.href='#/'
    },
    openChat() {
      gist.chat("open")
    },
    updateTierDescriptions () {
      for (var index = 0; index < this.campaign.tiers.length; index++) {
        console.log(this.campaign.tiers[index])
        this.campaign.tiers[index].prefix = this.campaign.tiers[0].prefix
        this.campaign.tiers[index].infix = this.campaign.tiers[0].infix
        this.campaign.tiers[index].suffix = this.campaign.tiers[0].suffix
        if (!this.campaign.tiers[index].justAdded) this.campaign.tiers[index].updated = true
        console.log(this.campaign.tiers[index])
      }
      console.log('updated Tier Descriptions', this.campaign.tiers)
    },
    extractId (graphId) {
      return parseInt(graphId.split('/').pop(), 10)
    },
    removeVariant (row, item) {
      let type = this.campaign.appliesTo === 'products' ? 'products' : 'collections'
      this.campaign[type][row].variants.splice(item, 1)
    },
    removeProduct (index) {
      let type = this.campaign.appliesTo === 'products' ? 'products' : 'collections'
      this.campaign[type].splice(index, 1)
    },
    validateNext () {
      if (this.step == 0) {
        if (this.campaign.title.length < 1) {
          return {
            disabled: true,
            message: 'Please enter a name for this discount campaign',
          }
        }
      }
      if (this.step === 1) {
        if ((this.campaign.appliesTo === 'products') && (this.campaign.products.length === 0)) {
          return {
            disabled: true,
            message: 'Please add some products before continuing',
          }
        }
        if ((this.campaign.appliesTo === 'collections') && (this.campaign.collections.length === 0)) {
          return {
            disabled: true,
            message: 'Please add some products before continuing',
          }
        }
      }
      if (this.step === 2) {
        for (var i = 0; i < this.campaign.tiers.length; i++) {
          var tier = this.campaign.tiers[i]
          if (isNaN(tier.prerequisiteQuantity)) {
            return {
              disabled: true,
              message: 'Please ensure you\'ve entered a quantity for each tier',
            }
          }
          if (isNaN(tier.value)) {
            return {
              disabled: true,
              message: 'Please ensure you\'ve entered an amount or percentage for each tier',
            }
          }
        }
      }
      return {
        disabled: false,
        message: '',
      }
    },
    selectProducts () {
      // console.log(ResourcePicker.Action.OPEN)
      const productPicker = ResourcePicker.create(this.appBridge, {
        resourceType: ResourcePicker.ResourceType.Product,
        options: {
          selectMultiple: true,
          showHidden: false,
        },
      })
      console.log(productPicker)
      const selectUnsubscribe = productPicker.subscribe(ResourcePicker.Action.SELECT, ({ selection }) => {
        // Do something with `selection`
        // console.log(selection)
        selection.forEach(item => {
          const shopifyId = this.extractId(item.id)
          const enlistedProductIdx = this.campaign.products.findIndex(product => product.shopifyId === shopifyId)
          const justAdded = enlistedProductIdx < 0

          const product = {
            id: justAdded ? (_.now() + _.random(1000)) : this.campaign.products[enlistedProductIdx].id,
            shopifyId,
            title: item.title,
            justAdded,
            variants: justAdded ? [] : this.products[enlistedProductIdx].variants,
          }

          item.variants.forEach(variant => {
            const shopifyId = this.extractId(variant.id)
            const variantIdx = product.variants.findIndex(v => v.shopifyId === shopifyId)
            const justAdded = variantIdx < 0
            const updatedVariant = {
              id: justAdded ? (_.now() + _.random(1000)) : product.variants[variantIdx].id,
              productId: product.id,
              shopifyId,
              title: !(typeof variant.title === 'undefined' || _.isEmpty(variant.title)) ? variant.title : product.title,
              justAdded,
              isOnlyVariant: item.hasOnlyDefaultVariant,
            }
            if (justAdded) {
              product.variants.push(_.cloneDeep(updatedVariant))
            } else {
              product.variants[variantIdx] = _.cloneDeep(updatedVariant)
            }
          })

          if (justAdded) {
            this.campaign.products.push(_.cloneDeep(product))
          } else {
            this.campaign.products[enlistedProductIdx] = _.cloneDeep(product)
          }
        })
        // console.log(this)
      })

      const cancelUnsubscribe = productPicker.subscribe(ResourcePicker.Action.CANCEL, () => {
        // Picker was cancelled
        // console.log('cancelled')
      })
      console.log(productPicker.dispatch(ResourcePicker.Action.OPEN))
    },
    selectCollections () {
      this.collectionPicker.dispatch(ResourcePicker.Action.OPEN)
      const selectCollectionUnsubscribe = this.collectionPicker.subscribe(ResourcePicker.Action.SELECT, ({ selection }) => {
        // Do something with `selection`
        console.log(selection)
        selection.forEach(item => {
          const shopifyId = this.extractId(item.id)
          const enlistedCollectionIdx = this.campaign.collections.findIndex(collection => collection.shopifyId === shopifyId)
          const justAdded = enlistedCollectionIdx < 0
          const collection = {
            id: justAdded ? (_.now() + _.random(1000)) : this.campaign.collections[enlistedCollectionIdx].id,
            shopifyId,
            title: item.title,
            justAdded,
          }
          if (justAdded) {
            this.campaign.collections.push(_.cloneDeep(collection))
          } else {
            this.campaign.collections[enlistedCollectionIdx] = _.cloneDeep(collection)
          }
        })
        // console.log(this)
      })

      const cancelCollectionUnsubscribe = this.collectionPicker.subscribe(ResourcePicker.Action.CANCEL, () => {
        // Picker was cancelled
        // console.log('cancelled')
      })
    },
    fetchCampaign () {
      axios.get('/tiers/' + this.id).then(response => {
        response.data.tz = Moments.getLocalTZ(response.data.data.tz)
        // response.data.startsAt = Moments.makeLocalTime(response.data.startsAt, Moments.TIMEZONE_GMT, false) // _.isEmpty(response.data.startsAt) ? moment().format('YYYY-MM-DD HH:mm:ss') : response.data.startsAt
        // response.data.endsAt = Moments.makeLocalTime(response.data.endsAt, Moments.TIMEZONE_GMT, true) // _.isEmpty(response.data.endsAt) ? null : response.data.endsAt
        // console.log(response.data)
        // this.setEndDate = !_.isNull(response.data.endsAt)
        this.startDate = Moments.convertToLocal(response.data.data.startsAt, response.data.tz) // moment(response.data.startsAt, 'YYYY-MM-DD HH:mm:ss'),
        this.startDay = this.startDate.format('YYYY-MM-DD HH:mm').split(' ')[0]
        this.startTime = this.startDate.format('YYYY-MM-DD HH:mm').split(' ')[1]

        // console.log('retrieved startsat',response.data.data.startsAt, this.startDay,this.startTime)
        // decide: do we want to show scheduler? only if start date is in future, or if enddate set at all
        if (response.data.data.startsAt > Moments.getCurrentMomentGMT().format('YYYY-MM-DD HH:mm')) this.useScheduler = true

        if (!_.isNull(response.data.data.endsAt)) {
          this.endDate = Moments.convertToLocal(response.data.data.endsAt, response.data.tz)
          this.endDay = this.endDate.format('YYYY-MM-DD HH:mm').split(' ')[0]
          this.endTime = this.endDate.format('YYYY-MM-DD HH:mm').split(' ')[1]
          // console.log('retrieved endsat',response.data.data.endsAt, this.endDay,this.endTime)
          this.useScheduler = true
          this.endCampaign = true
        }
        this.timezone = response.data.tz
        this.campaign = response.data.data
        this.$nextTick(() => {
          this.isLoaded = true
        })
        // console.log(this)

      }).catch(e => {
        pricelogger(e)
        //show feedback
      })
    },
    updateTime () {
      // todo: this is really easy to fuck up when tired, so lets leave till morning
      if (!_.isNull(this.startDay)) {
        let startDate = this.startDay + ' ' + (this.startTime || '00:00:00')
        let startDateUTC = Moments.convertToGMT(startDate, this.campaign.tz).format('YYYY-MM-DD HH:mm')
        // console.log(startDate,startDateUTC)
        this.campaign.startsAt = startDateUTC
      } else {
        this.campaign.startsAt = Moments.getCurrentMomentGMT()
      }

      if (!_.isNull(this.endDay)) {
        let endDate = this.endDay + ' ' + (this.endTime || '00:00:00')
        let endDateUTC = Moments.convertToGMT(endDate, this.campaign.tz).format('YYYY-MM-DD HH:mm')
        // console.log(endDate,endDateUTC)
        this.campaign.endsAt = endDateUTC
      } else {
        this.campaign.endsAt = null
      }
    },
    switchTab () {
      window.analytics.track('Campaign Wizard Step: ' + this.step, this.campaign)
      window.gist.track('Campaign Wizard Step: ' + this.step, this.campaign)
    },
    addTier () {
      this.campaign.tiers.push(Object.assign({}, this.defaultTier))
      this.updateTierDescriptions()
    },
    saveCampaign () {
      if ((typeof this.campaign.id !== 'undefined') && (this.campaign.id > 0)) {
        var method = 'PUT'
        var url = '/tiers/' + this.campaign.id
        window.analytics.track('Updated Campaign', this.campaign)
        window.gist.track('Updated Campaign', this.campaign)
      } else {
        var method = 'POST'
        var url = '/tiers'
        delete this.campaign.id
        window.analytics.track('Saved new campaign', this.campaign)
        window.gist.track('Saved new campaign', this.campaign)
      }
      axios.request({
        method: method,
        url: url,
        data: this.campaign,
      }).then(response => {
        const confirmation = Toast.create(this.appBridge, {
          message: 'Campaign Saved!',
          duration: 5000,
        })
        // confirmation.dispatch(Toast.Action.SHOW)
        this.$refs['campaign-saved'].show()
        // I don't think I need to do the below, as the saved state of the form should now match the POST and response
        /*response.data.tz = Moments.getLocalTZ(response.data.tz)
        response.data.startsAt = Moments.makeLocalTime(response.data.startsAt, Moments.TIMEZONE_GMT, false) // _.isEmpty(response.data.startsAt) ? moment().format('YYYY-MM-DD HH:mm:ss') : response.data.startsAt
        response.data.endsAt = Moments.makeLocalTime(response.data.endsAt, Moments.TIMEZONE_GMT, true) // _.isEmpty(response.data.endsAt) ? null : response.data.endsAt
        console.log(response.data)
        this.setEndDate = !_.isNull(response.data.endsAt)
        this.startDate = Moments.convertToLocal(response.data.startsAt, response.data.tz) // moment(response.data.startsAt, 'YYYY-MM-DD HH:mm:ss'),
        this.endDate = _.isNull(response.data.endsAt) ? null : Moments.convertToLocal(response.data.endsAt, response.data.tz)
        this.timezone = response.data.tz
        this.campaign = response.data.data*/
      }).catch(error => {
        pricelogger(error)
        // display feedback
      })
    },
  },
  mounted () {
    // console.log(this)
    if ((this.id !== 'undefined') && (this.id > 0)) {
      this.fetchCampaign()
    } else {
      this.$nextTick(() => {
        this.isLoaded = true
      })
    }
    this.timezoneList = Moments.getTzOptions().map(zone => {
      return zone.value
    })
    // console.log(this.timezoneList)
    this.startDay = this.startDate.format('YYYY-MM-DD')
    this.startTime = this.startDate.format('HH:mm')

    this.isChrome = window.navigator.userAgent.includes('hrome')
    this.isFree = JSON.parse(window.SHOP).is_free || false
    if (this.isFree) {
      this.campaign.appliesTo = 'order';
      this.campaign.isPrice = false;
    }

  },
  props: ['shopSettings', 'shopUrl', 'appBridge', 'collectionPicker', 'productPicker', 'id'],
  watch: {
    showQuantitiesAs: function (val) {
      console.log(val)
      if (val === 'Basic') this.campaign.settings.productTableHandle = 'basic'
      if (val === 'Range') this.campaign.settings.productTableHandle = 'range'
    },
    'campaign.isPrice': function (campaign) {
      console.log(campaign)
      if (this.campaign.isPrice) {
        this.campaign.settings.productTableHandle = 'pricebasic'
        if (this.isLoaded) {
          this.campaign.tiers[0].infix = 'Pay Just'
          this.campaign.tiers[0].suffix = 'Each'
          this.updateTierDescriptions()
        }
      } else {

        if (this.isLoaded) {
          this.campaign.tiers[0].infix = 'Get'
          this.campaign.tiers[0].suffix = 'Off'
          this.updateTierDescriptions()
        }
        if (this.showQuantitiesAs === 'Basic') this.campaign.settings.productTableHandle = 'basic'
        if (this.showQuantitiesAs === 'Range') this.campaign.settings.productTableHandle = 'range'
      }
      console.log(this.campaign)

    },
    startDay: function (val) {
      this.updateTime()
    },
    endDay: function (val) {
      this.updateTime()
    },
    startTime: function (val) {
      this.updateTime()
    },
    endTime: function (val) {
      this.updateTime()
    },
    'campaign.tz': function (val) {
      this.updateTime()
    },
    step: function (val) {
      window.analytics.track('Campaign Wizard Step: ' + this.step, this.campaign)
    },

  },

}</script>

<style scoped>
.btn {
  text-wrap: inherit;
  white-space: inherit;
}

.display-2, .display-3 {
  margin-bottom: 25px;
  margin-top: 20px;
}
</style>
